var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container py-3 py-lg-6"},[_c('div',{staticClass:"px-lg-7"},[_c('iframe',{staticClass:"w-100 yt-video",attrs:{"src":"https://www.youtube.com/embed/H4FZPDVeDpY","title":"E Auction demo","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])])
}]

export { render, staticRenderFns }